import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	Output
} from '@angular/core';
import { ProfileUpdateDataServiceProvider } from '@web-services/profile/profile-update.data.service';
import { AccountServiceWebProvider } from '@web-services/user/account.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ProfileUpdateServiceProvider } from '@web-services/profile/profile-update.service';
import { User } from '@models/models';
import { finalize, switchMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
	selector: 'account-details',
	template: require('./account-details.html'),
	styles: [require('./account-details.scss')]
})
export class AccountDetailsComponent implements OnDestroy {
	@Input() user: User;
	@Output() onUserDataChange: EventEmitter<void> = new EventEmitter();

	disableButton: boolean;
	private unsubscribe: Subject<any> = new Subject();

	constructor(
		private profileUpdateService: ProfileUpdateDataServiceProvider,
		private profileService: ProfileUpdateServiceProvider,
		private accountService: AccountServiceWebProvider,
		private messageService: MessageService
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	changeName(): void {
		if (this.profileService.validateName(this.user.firstName)) {
			this.disableButton = true;

			this.profileUpdateService
				.changeUserName(this.user)
				.pipe(
					takeUntil(this.unsubscribe),
					switchMap(() => this.accountService.getUserWeb()),
					finalize(() => (this.disableButton = false))
				)
				.subscribe(
					(user: User): void => this.successUserDataChange(),
					(): void => this.messageService.showToaster('e_0', 'general')
				);
		} else {
			this.messageService.showToaster('e_0', 'companyUsers');
		}
	}

	private successUserDataChange(): void {
		this.onUserDataChange.emit();
		this.messageService.showToaster('s_1', 'profile');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/profile/account-details/account-details.ts